module.exports = __webpack_public_path__ + "img/configillustration.f9944f52.svg";